import {
  type Conditions,
  type Restrictions,
  ItemRestriction,
  PROMOTION_TYPE,
} from 'typings'
import { SCOPE_OPTIONS } from '../Form/ItemsView/typing'
import { Gift } from './gift'
import type { PromotionBase } from './promotion'
import { GenericShipping, RegularFreeShipping } from './shipping'

export type RegularConditions = Conditions

export enum RegularScopeApplyTo {
  allItems = 'allItems',
  filteredItems = 'filteredItems',
}

export type RegularScope = {
  applyTo: RegularScopeApplyTo
  [SCOPE_OPTIONS.SKUS]: ItemRestriction | undefined
  [SCOPE_OPTIONS.BRANDS]: ItemRestriction | undefined
  [SCOPE_OPTIONS.CATEGORIES]: ItemRestriction | undefined
  [SCOPE_OPTIONS.COLLECTIONS]: ItemRestriction | undefined
  [SCOPE_OPTIONS.PRODUCTS]: ItemRestriction | undefined
}

export type Nominal = {
  type: RegularBenefitVariant.Nominal
  value: number
}

type NominalShippingBase = {
  type: RegularBenefitVariant.NominalShipping
  value: number
}

type PercentualShippingBase = {
  type: RegularBenefitVariant.PercentualShipping
  value: number
}

type MaxShippingBase = {
  type: RegularBenefitVariant.MaxShipping
  value: number
}

export type NominalShipping = GenericShipping<NominalShippingBase>
export type PercentualShipping = GenericShipping<PercentualShippingBase>
export type MaxShipping = GenericShipping<MaxShippingBase>

export type Percentual = {
  type: RegularBenefitVariant.Percentual
  value: number
}

export type MaxPrice = {
  type: RegularBenefitVariant.MaxPrice
  value: number
}

export enum ApplyOnStatus {
  Invoiced = 'invoiced',
  PaymentApproved = 'paymentApproved',
}

export type NominalLoyalty = {
  type: RegularBenefitVariant.NominalLoyalty
  value: number
  status: ApplyOnStatus
}

export type RegularGift = Gift<RegularBenefitVariant.Gift>

export type PercentualLoyalty = {
  type: RegularBenefitVariant.PercentualLoyalty
  value: number
  status: ApplyOnStatus
}

export type Formula = {
  type: RegularBenefitVariant.Formula
  expression: string
}

export type PriceTable = {
  type: RegularBenefitVariant.PriceTable
  value: string
}

export type RegularBenefit =
  | Nominal
  | Percentual
  | NominalShipping
  | PercentualShipping
  | MaxShipping
  | RegularFreeShipping
  | MaxPrice
  | NominalLoyalty
  | RegularGift
  | PercentualLoyalty
  | Formula
  | PriceTable

export type RegularEffect = {
  scope: RegularScope | undefined
  benefit: RegularBenefit | undefined
}

export enum RegularBenefitVariant {
  Nominal = 'nominal',
  Percentual = 'percentual',
  Formula = 'formula',
  NominalShipping = 'nominalShipping',
  PercentualShipping = 'percentualShipping',
  FreeShipping = 'freeShipping',
  MaxShipping = 'maxShipping',
  MaxPrice = 'maxPrice',
  Gift = 'gift',
  NominalLoyalty = 'nominalLoyalty',
  PercentualLoyalty = 'percentualLoyalty',
  PriceTable = 'priceTable',
}

export interface RegularPromotion extends PromotionBase {
  type: PROMOTION_TYPE.REGULAR
  regular: RegularEffect
  conditions: RegularConditions
  restrictions: Restrictions
}
